import { render, staticRenderFns } from "./FormSet.vue?vue&type=template&id=76361251&scoped=true"
import script from "./FormSet.vue?vue&type=script&lang=ts"
export * from "./FormSet.vue?vue&type=script&lang=ts"
import style0 from "./FormSet.vue?vue&type=style&index=0&id=76361251&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76361251",
  null
  
)

export default component.exports